import React from "react";
import {Link, useParams} from "react-router-dom";

import {RoleViewComponent} from "ppm-react-authentication";
import {ROLES_API_URL, ROLES_PERMISSIONS_API_URL} from "../../helpers/api-urls";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import AuthorizationChecker from "security/AuthorizationChecker";
import { withTranslation } from "react-i18next";

const PagesDetailRoles = (props) =>{
    const params = useParams();
    const {id = 0} = params;

    return ( 
        <>
            <div className="page-content">
                    <title>{props.t("ROLE")}</title>
                
                <div className="mb-4">
                    <Breadcrumbs title={props.t("ROLE")} breadcrumbItem={props.t("ROLE_DETAIL")}/>
                    <Link className="btn btn-info" to={"/pages-roles"}>{props.t("RETURN_TO_LIST")}</Link>

                    { AuthorizationChecker.isGranted(["EDIT_ROLES"]) && ( <Link className="btn btn-info ms-3" to={"/pages-roles/"+id+"/edit"}>{props.t("EDIT")}</Link> )}
                    { AuthorizationChecker.isGranted(["ADD_ROLES"]) && ( <Link className="btn btn-info ms-3" to={"/pages-roles/add"}>{props.t("ADD")}</Link> )}
                </div>
                <RoleViewComponent 
                    id={id}
                    apiUrl={ROLES_API_URL}
                    permissionPath="/pages-permissions"
                    apiRolePermissionUrl={ROLES_PERMISSIONS_API_URL}
                    showAssociatedPermissionsEdit = { AuthorizationChecker.isGranted(["EDIT_PERMISSIONS"])}
                    showAssociatedPermissionsView = { AuthorizationChecker.isGranted(["READ_PERMISSIONS"])}
                    showAssociatedPermissionsDelete  = { AuthorizationChecker.isGranted(["DELETE_PERMISSIONS"])}
                    onDelete={(event, elt) => {}}
                    Link={Link}
                />
            </div>
        </>
    );
}

export default withTranslation()(PagesDetailRoles)
